// extracted by mini-css-extract-plugin
export var blog = "single-blog-module--blog--h5BBJ";
export var center = "single-blog-module--center--OK0IW";
export var post = "single-blog-module--post--ZGDfj";